export function getLiferayUserName() {
  if (typeof window.Liferay !== "undefined" && window.Liferay.ThemeDisplay) {
    return window.Liferay.ThemeDisplay.getUserName();
  }
  console.warn(
    "Liferay is not defined or running outside the Liferay environment"
  );
  return null;
}

export function getLiferayUserId() {
  if (window.Liferay && window.Liferay.ThemeDisplay.isSignedIn()) {
    return window.Liferay.ThemeDisplay.getUserId();
  }
  return null;
}


export function getLiferayFirstName(callback) {
  if (window.Liferay && window.Liferay.ThemeDisplay.isSignedIn()) {
    window.Liferay.Service(
      '/user/get-user-by-id',
      {
        userId: window.Liferay.ThemeDisplay.getUserId()
      },
      (user) => {
        if (user && user.firstName) {
          callback(user.firstName); // Call the callback with the fetched screen name
        } else {
          callback(null);
        }
      }
    );
  } else {
    callback(null);
  }
}

export function getLiferayUserRoles(callback) {
  if (window.Liferay && window.Liferay.ThemeDisplay.isSignedIn()) {
    window.Liferay.Service(
      '/role/get-user-roles',
      {
        userId: window.Liferay.ThemeDisplay.getUserId()
      },
      function (response) {
        var roles = [];
        response.forEach(function (e) {
          roles.push(e.name);
        });
        callback(roles);
      }
    );
  } else {
    callback(null);
  }
}

export function getLiferayUserScreenName(callback) {
  if (window.Liferay && window.Liferay.ThemeDisplay.isSignedIn()) {
    window.Liferay.Service(
      '/user/get-user-by-id',
      {
        userId: window.Liferay.ThemeDisplay.getUserId()
      },
      (user) => {
        if (user && user.screenName) {
          callback(user.screenName); // Call the callback with the fetched screen name
        } else {
          callback(null);
        }
      }
    );
  } else {
    callback(null);
  }
}